import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiService } from "../services/apiService";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const code = params.get("code");

        if (!code) {
          throw new Error("No authorization code received");
        }

        const response = await apiService.post("/api/auth/google", { code });
        localStorage.setItem("auth_token", response.token);
        navigate("/dashboard");
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/login");
      }
    };

    handleCallback();
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500" />
    </div>
  );
};

export default AuthCallback;
